import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HeroSection from "@/components/HeroSection";
import CategoriesSection from "@/components/CategoriesSection";
import FeaturesSection from "@/components/FeaturesSection";
import AnnouncementsSection from "@/components/AnnouncementsSection";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header showSearch={false} />
      
      <main className="flex-grow">
        <HeroSection onScrollToResources={() => navigate('/templates')} />
        <AnnouncementsSection />
        <CategoriesSection />
        <FeaturesSection />
      </main>
      
      <Footer />
    </div>
  );
};

export default Index;
